"use strict";
/**
 * @license
 * Copyright 2020 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Uint64 } from "#src/util/uint64.js";
export var VisibleSegmentEquivalencePolicy = /* @__PURE__ */ ((VisibleSegmentEquivalencePolicy2) => {
  VisibleSegmentEquivalencePolicy2[VisibleSegmentEquivalencePolicy2["MIN_REPRESENTATIVE"] = 0] = "MIN_REPRESENTATIVE";
  VisibleSegmentEquivalencePolicy2[VisibleSegmentEquivalencePolicy2["MAX_REPRESENTATIVE"] = 1] = "MAX_REPRESENTATIVE";
  VisibleSegmentEquivalencePolicy2[VisibleSegmentEquivalencePolicy2["REPRESENTATIVE_EXCLUDED"] = 2] = "REPRESENTATIVE_EXCLUDED";
  VisibleSegmentEquivalencePolicy2[VisibleSegmentEquivalencePolicy2["NONREPRESENTATIVE_EXCLUDED"] = 4] = "NONREPRESENTATIVE_EXCLUDED";
  return VisibleSegmentEquivalencePolicy2;
})(VisibleSegmentEquivalencePolicy || {});
export function isBaseSegmentId(segmentId) {
  return segmentId.high >>> 31 ? false : true;
}
export const UNKNOWN_NEW_SEGMENT_ID = new Uint64(4294967295, 4294967295);
